import {
  Box,
  CardContent,
  Container,
  Typography,
  Card,
  Collapse,
} from "@mui/material";
import React, { useState } from "react";

import {
  circle_background,
  graduation,
  handshak,
  heart,
  leader,
  locations,
  networking,
} from "../../assets/images";
import "swiper/css";
import "swiper/css/pagination";
import {
  NetworkCheck,
  LocationOn,
  Handshake,
  People,
  School,
} from "@mui/icons-material";
import StayConnected from "./StayConnected";
import PartnerUs from "./PartnerUs";
import BecomeMentor from "./BecomeMentor";
import BecomeLearner from "./BecomeLearner";

const CardSection = () => {
  const [activeCard, setActiveCard] = useState(1);
  const cardInfo = [
    {
      id: 1,
      heading: "Stay Connected",
      content:
        "We are eager to share updates about projects, our students’ journeys, as well as events and other information.",
      img: networking,
      icon: <NetworkCheck sx={{ width: 300 }} />,
    },
    {
      id: 2,
      heading: "Partner with us",
      content:
        "EAGLE Learning units are currently present in Zimbabwe with more locations to be added soon.",
      img: handshak,
      icon: <LocationOn sx={{ width: 300 }} />,
    },
    {
      id: 3,
      heading: "Become a Learner",
      content:
        "Our students need passionate individuals to guide them on their education and spiritual journey.",
      img: graduation,
      icon: <School sx={{ width: 300 }} />,
    },
    {
      id: 4,
      heading: "Become a Mentor",
      content:
        "Our students need passionate individuals to guide them on their education and spiritual journey.",
      img: leader,
      icon: <People sx={{ width: 300 }} />,
    },
  ];

  return (
    <Box
      sx={{
        width: "100vw",
        mb: { md: 20 },
        mt: { md: 10 },
        pt: { xs: 5 },
        pb: { md: 5 },
        bgcolor: "#F5F5F5",
        /* background: "linear-gradient(to bottom, #F5F5F5,  #F5F5F5, #FFFFFF)", */
      }}
      on
    >
      <Container
        sx={{
          backgroundImage: `url(${circle_background})`,
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          height: { md: "80vh" },
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
        }}
      >
        <Container
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              width: { xs: "100%", md: "50%" },
              mb: "1rem",
              textAlign: "center",
            }}
          >
            How to get involved as an EAGLE Learner
          </Typography>
        </Container>
        <Container
          sx={{
            height: { md: "50vh" },
            display: "flex",
            flexDirection: { xs: "row", md: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            mb: 5,
            p: 0.5,
            px: 0,
            bgcolor: { xs: " #d8d8d8", md: "transparent" },
            borderRadius: { xs: 3 },
          }}
        >
          {cardInfo.map((info) => (
            <>
              <Card
                onClick={() => {
                  setActiveCard(info.id);
                  console.log(activeCard);
                }}
                sx={{
                  width: { xs: "100%", md: 250 },
                  height: 400,
                  display: { xs: "none", md: "block" },
                  borderRadius: 5,
                  boxShadow: "none",
                  mb: { xs: 2 },
                  borderStyle: "none",
                  overflow: "hidden",
                  cursor: "pointer",
                  transition: "transform 0.10s, box-shadow 0.10s",
                  "&:hover": {
                    transform: "scale(1.0)",
                    boxShadow: "0 8px 20px rgba(0, 0, 0, 0.2)",
                  },
                  "&::before": {
                    content: '""',
                    position: "absolute",
                    top: "-100%",
                    left: 0,
                    width: "100%",
                    height: "100%",
                    background:
                      "linear-gradient(to bottom, #DB5430, #DB5430, rgba(112, 59, 20, 0))",
                    transition: "top 0.5s ease-in-out",
                    zIndex: -1,
                  },
                  "&:hover::before": {
                    top: 0,
                  },
                  mr: 1,
                }}
              >
                <CardContent
                  sx={{
                    background: "linear-gradient(to bottom, #DB5430, #F5F5F5)",
                    height: "inherit",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <img src={info.img} alt="icon-image" width={70} />
                  <Typography
                    variant="h6"
                    color="primary.dark"
                    sx={{
                      textTransform: "uppercase",
                      maxWidth: "70%",
                      textAlign: "center",
                      mt: 3,
                    }}
                  >
                    {info.heading}
                  </Typography>
                  <Typography color="primary.dark" sx={{ textAlign: "center" }}>
                    {info.content}
                  </Typography>
                </CardContent>
              </Card>
              <Box
                key={info.id}
                onClick={() => {
                  setActiveCard(info.id);
                  console.log(activeCard);
                }}
                sx={{
                  width: "100%",
                  height: 50,
                  bgcolor: `${
                    activeCard === info.id ? "primary.main" : "transparent"
                  }`,
                  display: { xs: "flex", md: "none" },
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  borderRadius: 3,
                }}
              >
                <img
                  src={info.img}
                  alt="icon-image"
                  style={{ height: "40px", width: "40px" }}
                />
              </Box>
            </>
          ))}
        </Container>
      </Container>
      <Collapse in={activeCard === 1} timeout="auto" unmountOnExit>
        <StayConnected />
      </Collapse>
      <Collapse in={activeCard === 2} timeout="auto" unmountOnExit>
        <PartnerUs />
      </Collapse>
      <Collapse in={activeCard === 3} timeout="auto" unmountOnExit>
        <BecomeLearner />
      </Collapse>
      <Collapse in={activeCard === 4} timeout="auto" unmountOnExit>
        <BecomeMentor />
      </Collapse>
    </Box>
  );
};

export default CardSection;
